var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.293 4.418a1 1 0 0 1 1.338-.068l.076.068 7 7a1 1 0 0 1 .249.415l.013.05q.03.117.03.243 0 .124-.03.24l-.013.05a1 1 0 0 1-.165.318 1 1 0 0 1-.084.098l-7 7a1 1 0 0 1-1.414-1.413l5.293-5.293H5a1 1 0 0 1 0-2h11.586l-5.293-5.293-.069-.077a1 1 0 0 1 .069-1.338"
  })));
};
export default Svg24;